/* eslint-disable camelcase */

import { sendCategoryFilterEvent } from '@ebay/presence-ui/lib/event-triggers';
import { get } from '@ebay/presence-ui/lib/object-helpers';
import { hasCurrentCategory } from '../str-left-nav/util';

const CLS = {
    allCatsLink: 'str-category-tree__all-cats-link',
    expanded: 'expanded',
    L1CatHidden: 'L1CatHidden'
};
const SEL = {
    showSubCatsBtn: 'button.control__chevron-btn'
};
const SHOW_MORE_COUNT = 15;

export default class {
    onCreate(input) {
        const categories = get(input, 'page.modules.STORE_CATEGORIES_MODULE.categories', []);
        const showMore = get(input, 'page.modules.STORE_CATEGORIES_MODULE.showMore', {});
        const isL1CatHidden = true;
        setUxProps(categories);
        this.handleShowMore(categories, isL1CatHidden, false);
        this.state = {
            categories,
            allCatsIsCurrent: !hasCurrentCategory(categories),
            isL1CatHidden: isL1CatHidden,
            showMoreCount: SHOW_MORE_COUNT,
            showMoreLabel: get(showMore, 'offCallToAction.text', ''), 
            showLessLabel: get(showMore, 'onCallToAction.text', '')
        };
    }
    onInput(input) {
        return {
            heading: get(input, 'page.modules.STORE_CATEGORIES_MODULE.header.textSpans.0.text', ''),
            headingUrl: get(input, 'page.modules.STORE_CATEGORIES_MODULE.header.action.URL', ''),
            headingTracking: JSON.stringify(get(input,
                'page.modules.STORE_CATEGORIES_MODULE.header.action.trackingList', {}))
        };
    }
    handleTreeClick(evt) {
        evt.preventDefault();
        const showSubCatsBtn = evt.target.closest(SEL.showSubCatsBtn);
        const link = evt.target.closest('a');
        if (showSubCatsBtn) { // Open and close sub-categories
            const catId = showSubCatsBtn.getAttribute('data-cat-id');
            this.toggleSublist(this.state, catId);
        } else if (link) { // Load category results
            loadCategoryView(link.href, evt);
            this.openList(this.state, link);
            this.setStateDirty('categories');
        }
    }
    toggleSublist(state, catId, isExpanded) {
        if (catId) {
            // When opening a sublist, close all the others.
            closeUnlessHasCatId(state.categories, catId);

            toggleExpanded(state.categories, catId, isExpanded);
            this.setStateDirty('categories');
            doubleRaf(() => {
                updateExpandedClass(state.categories, catId);
                this.setStateDirty('categories');
            });
        }
    }
    openList(state, link) {
        if (state && link) {
            let catId = link.getAttribute('data-cat-id');
            if (link.classList.contains(CLS.allCatsLink)) {
                catId = '-1'; // If "All Categories" link, set category.isCurrentCategory to false for all.
            }
            setCurrentCategory(state.categories, catId);
            state.allCatsIsCurrent = !hasCurrentCategory(state.categories);
            this.toggleSublist(state, catId, true);
        }
    }
    toggleShowMore() {
        this.state.isL1CatHidden = !this.state.isL1CatHidden;
        this.handleShowMore(this.state.categories, this.state.isL1CatHidden, true);
    }
    // Assumes that category._ux property exists.
    // Loops backwards through the L1 categories setting the itemAriaHidden
    // property that is needed for the "Show More" functionality.
    handleShowMore(categories, isL1CatHidden, closeExpanded) {
        for (let i = categories.length - 1; i >= 0; i--) {
            const cat = categories[i];
            if (cat._ux.isExpanded && !closeExpanded) {
                break;
            }
            if (i >= SHOW_MORE_COUNT) {
                if (isL1CatHidden) { // Close
                    cat._ux.isL1CatHidden = true;
                    cat._ux.L1CatHiddenClass = CLS.L1CatHidden;
                    cat._ux.isExpanded = false;
                    closeUnlessHasCatId(cat.categories, -1);
                } else { // Open
                    cat._ux.isL1CatHidden = false;
                    this.setStateDirty('categories');
                    doubleRaf(() => {
                        cat._ux.L1CatHiddenClass = '';
                        this.setStateDirty('categories');
                    });
                }
            }
        }
    }
}

function doubleRaf(callback) {
    requestAnimationFrame(() => requestAnimationFrame(() => {
        callback();
    }));
}

function closeUnlessHasCatId(categories, catId) {
    if (categories && categories.length) {
        for (let i = 0, n = categories.length; i < n; i++) {
            const cat = categories[i];
            const categoryId = cat._ux.categoryId;
            if (!hasCategeoryId(cat.categories, catId) && catId !== categoryId) {
                cat._ux.isExpanded = false;
                cat._ux.expandedClass = '';
            }
            closeUnlessHasCatId(cat.categories, catId);
        }
    }
}

function toggleExpanded(categories, categoryId, isExpanded) {
    if (categories && categories.length && categoryId) {
        for (let i = 0, n = categories.length; i < n; i++) {
            const cat = categories[i];
            if (cat._ux.categoryId === categoryId) {
                if (isExpanded !== undefined) {
                    cat._ux.isExpanded = isExpanded;
                } else {
                    cat._ux.isExpanded = !cat._ux.isExpanded;
                }
            }
            toggleExpanded(cat.categories, categoryId, isExpanded);
        }
    }
}

function updateExpandedClass(categories, categoryId) {
    if (categories && categories.length && categoryId) {
        for (let i = 0, n = categories.length; i < n; i++) {
            const cat = categories[i];
            cat._ux.expandedClass = cat._ux.isExpanded ? CLS.expanded : '';
            updateExpandedClass(cat.categories, categoryId);
        }
    }
}

function loadCategoryView(href, evt) {
    sendCategoryFilterEvent({
        url: href,
        clickEvent: evt
    });
}

// It's expected that the "categories" have already had the current category set.
function setUxProps(categories) {
    if (categories && categories.length) {
        for (let i = 0, n = categories.length; i < n; i++) {
            const cat = categories[i];
            if (!cat._ux) {
                cat._ux = {};
            }
            if (!cat._ux.categoryId) {
                cat._ux.categoryId = getCategoryId(cat);
            }
            cat._ux.isExpanded = hasCurrentCategory(cat.categories) || cat.isCurrentCategory;
            cat._ux.expandedClass = cat._ux.isExpanded ? CLS.expanded : '';
            cat._ux.L1CatHiddenClass = '';
            setUxProps(cat.categories);
        }
    }
}

function setCurrentCategory(categories, categoryId) {
    if (categories && categories.length && categoryId) {
        for (let i = 0, n = categories.length; i < n; i++) {
            if (categories[i]._ux.categoryId === categoryId) {
                categories[i].isCurrentCategory = true;
            } else {
                categories[i].isCurrentCategory = false;
            }
            setCurrentCategory(categories[i].categories, categoryId);
        }
    }
}

function hasCategeoryId(categories, categoryId) {
    if (categories && categories.length && categoryId) {
        for (let i = 0, n = categories.length; i < n; i++) {
            if (categories[i]._ux.categoryId === categoryId) {
                return true;
            }
            const hasCatId = hasCategeoryId(categories[i].categories, categoryId);
            if (hasCatId) {
                return hasCatId;
            }
        }
    }
}

function getCategoryId(category) {
    const _storecat = get(category, 'action.params._storecat', '').toString();
    const store_cat = get(category, 'action.params.store_cat', '').toString();
    const _sacat = get(category, 'action.params._sacat', '').toString();

    if (_storecat || store_cat) { // _storecat is legacy param left over from Lexington app.
        return _storecat || store_cat;
    } else if (_sacat) { // eBay categories
        return _sacat;
    }
}
